import { FC } from 'react'
import { useTranslate } from 'react-admin'
import { Box, Chip, Typography } from '@mui/material'

interface EnvironmentDisplayProps {
  name: string;
}

export const EnvironmentDisplay: FC<EnvironmentDisplayProps> = ({ name }) => {
  const translate = useTranslate()

  return (
    <Box sx={{ mb: 2 }}>
      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>
        {translate('data.environment')}
      </Typography>
      <Chip
        label={name}
        size="small"
        variant="outlined"
        color="primary"
        sx={{
          fontWeight: 600,
          fontSize: '0.8rem',
        }}
      />
    </Box>
  )
}
